<div class="pm-emoji-container">
  <div
    class="pm-emoji"
    [ngStyle]="{
      fontSize: size + 'px'
    }"
  >
    {{ emoji }}
  </div>
</div>
